
import { computed, defineComponent } from 'vue';
import {
  Modal,
} from 'ant-design-vue';
import myButton from './Button.vue';

export default defineComponent({
  components: {
    aModal: Modal,
    myButton,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    okText: {
      type: String,
      default: '确认',
    },
    cancelText: {
      type: String,
      default: '取消',
    },
    zIndex: {
      type: Number,
    },
  },
  emits: ['onCancel', 'onOk'],
  setup(props, { emit }) {
    const basicVisible = computed(() => props.visible);
    const basicLoading = computed(() => props.loading);

    const onCancel = () => {
      emit('onCancel');
    };

    const onOk = async () => {
      emit('onOk');
    };
    return {
      basicVisible,
      basicLoading,
      onCancel,
      onOk,
    };
  },
});
